export const Size = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export const Skin = {
  standard: 'standard',
  premium: 'premium',
  success: 'success',
};

export const sizesMap = {
  small: 30,
  medium: 54,
  large: 102,
};

export const dataHooks = {
  tooltip: 'circular-progressbar-tooltip',
  circularProgressBar: 'circular-progress-bar',
  errorIcon: 'error-icon',
  successIcon: 'success-icon',
};
